import React from "react";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import Note from "./Note";

const stringToColor = (str) => {
	let hash = 0;
	let i;

	for (i = 0; i < str.length; i += 1) {
		hash = str.charCodeAt(i) + ((hash << 5) - hash);
	}
	let color = "#";
	for (i = 0; i < 3; i += 1) {
		const value = (hash >> (i * 8)) & 0xff;
		color += `00${value.toString(16)}`.substr(-2);
	}
	return color;
};

const stringAvatar = (name) => {
	return {
		style: {
			backgroundColor: stringToColor(name),
		},
		children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
	};
};

const useStyles = makeStyles(() => ({
	primaryNotes: {
        minHeight: "45%",
        overflowY: "auto",
    },
    secondaryNotes: {
        minHeight: "75%",
        overflowY: "auto",
    }
}));

const NoteList = ({ notes, handleDelete, isDeleteProgress }) => {
	const classes = useStyles();
	return (
		<Box className={ notes && notes.length > 2 ? classes.secondaryNotes : classes.primaryNotes}>
			{notes.map((note) => {
				const subHeading = `${note.created_by} - ${moment(note.created_date).format(
					"MMMM Do YYYY, h:mm a"
				)}`;
				const showNote = !note.invalidated_datetime;

				return (
					<>
						{showNote && (
							<>
								<Note
									avatarProps={stringAvatar(note.created_by)}
									heading={note.subject}
									subHeading={subHeading}
									appStatus={note.application_status}
									description={note.message}
									showDeleteIcon={
										(window.authProvider?.account?.userName).toLowerCase() ===
										note.created_by_email.toLowerCase()
									}
									handleDelete={() => handleDelete(note)}
									isLoading={
										isDeleteProgress?.status && note.id === isDeleteProgress?.id
									}
								/>
								<hr />
							</>
						)}
					</>
				);
			})}
		</Box>
	);
};

export default NoteList;
